import React from 'react';
import './MessageInputSection.scss'; 
import mic from '../../images/mic.svg'; 
import upload from '../../images/upload.svg'; 
import send from '../../images/paper-plane.svg'; 

const MessageInputSection = ({ message, setMessage, handleFileChange, handleSendButtonClick }) => {
  
  const handlePaste = (event) => {
    event.preventDefault();
    let paste = (event.clipboardData || window.clipboardData).getData('text');
    paste = paste.trim();
    setMessage(paste);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && message.trim() !== '') {
      event.preventDefault(); // Prevent default behavior (new line)
      handleSendButtonClick();
    }
  };

  
  return (
    <div className="message-input">
      <div className='mid-section'>
        <img className="icon-mic" src={mic} alt="Mic" />
        <textarea
          className="textarea"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onPaste={handlePaste}
          onKeyDown={handleKeyDown}
          placeholder="What is in your mind?"
        />
        <label htmlFor="fileInput">
          <img className="file-upload" src={upload} alt="Upload" />
        </label>
        <input
          id="fileInput"
          type="file"
          multiple
          onChange={handleFileChange}
          accept=".pdf"
          style={{ display: 'none' }}
        />
        <img
          className="send-button"
          src={send}
          alt="Send"
          onClick={handleSendButtonClick}
        />
      </div>
    </div>
  )
}

export default MessageInputSection;
